import { useCallback, useMemo } from "react";
import { CommunityTagModel } from "../models/CommunityTagModel";

type Props = {
    values: CommunityTagModel[];
    suggests: string[];
    typeValue: string;
    onSelect: (tag: string) => void;
}

export const CommunitySuggestList = ({ values, suggests, typeValue, onSelect }: Props) => {
    const filteredList = useMemo(() => suggests.filter(s => !values.find(v => v.label === s) && s.toLowerCase().startsWith(typeValue.toLowerCase())), [suggests, typeValue]); 


    const _button = useCallback((suggest: string, value: string) => {
        const result = [
            suggest.slice(0, value.length),
            suggest.slice(value.length)
        ];
        return (
            <>
                <strong>{result[0]}</strong>
                {result[1]}
            </>
        )
    }, []);

    return (
        <div className="community-tag-suggest-list">
            <div>
                <span className="title">Popular Categories</span>
                {filteredList.map((s,i) => (
                    <button type="button" key={i} onPointerDown={() => onSelect(s)}>
                        { _button(s, typeValue) }
                    </button>
                ))}
            </div>
            {/* <div>
                <span className="title">Add New</span>
                <strong>"{typeValue}"</strong>
            </div> */}
        </div>
    )
}